<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <MenuLateral/>

                <main role="main" class="col-12 col-lg-9 px-4 mb-3">
                    <router-view></router-view>
                </main>
            </div>
        </div>
    </div>
</template>

<script>
    import MenuLateral from './Menu'

    export default {
        name: 'Corpo',

        components: {
            MenuLateral
        },

        data() {
            return {
                menus: ''
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    main{
        margin-top: -34px;
    }
</style>
